import { render, staticRenderFns } from "./AscReportDataItem.vue?vue&type=template&id=ef72f2aa&"
import script from "./AscReportDataItem.vue?vue&type=script&lang=js&"
export * from "./AscReportDataItem.vue?vue&type=script&lang=js&"
import style0 from "./AscReportDataItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports